export default "__VITE_ASSET__$wIO6QOF__"